import razorpayPay from "./payment"
export default razorpayPay